const options: Intl.DateTimeFormatOptions = {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
  timeZone: 'Europe/Zurich', // make sure the swiss time zone is used
};

/**
 * Will format dates and render a string like "January 1, 2020"
 * Note: that the time is set to 1am in switzerland. This is not correct for news.
 * News should be saved with a time because a news article published on Jan 1 at 10am
 * is published on the the 31st of December from a US perspective.
 */
export function parseDate(date: Date | string): string {
  return new Intl.DateTimeFormat('en-US', options).format(
    new Date(date).setUTCHours(1, 0, 0, 0), // news don't have a time, so we set it to 1am to avoid timezone issues
  );
}
